import getMaxFavoriteSuggestionCounts from './getMaxFavoriteSuggestionCounts';
import { isFolderInFavorites } from 'owa-favorites';
import getFoldersForMoveTo from 'owa-mail-store/lib/utils/getFoldersForMoveTo';
export default function getFavoriteFolderSuggestions(findText) {
    var maxFolderSuggestions = getMaxFavoriteSuggestionCounts().folder;
    // Find top matching folders not already in favorites
    var folders = getFoldersForMoveTo(findText, maxFolderSuggestions, function (folderId) { return !isFolderInFavorites(folderId); }).folders; /* customFilter */
    var items = folders.map(function (folder) {
        var folderDisplayName = folder.displayName;
        return {
            id: folder.folderId,
            data: folderDisplayName,
            type: 0 /* Folder */,
            relevance: 0 /* Relevance scores will be supplied by providers in the future */,
        };
    });
    return items;
}
//# sourceMappingURL=getFavoriteFolderSuggestions.js.map